export const theme = {
  bg: {
    wash: "#f0f0f0",
  },
};
